import React from 'react';
import { Container } from 'react-bootstrap';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-light py-3 mt-auto">
            <Container fluid>
                <div className="text-center text-muted">
                    <small>
                        &copy; {currentYear} Echo Fire and Medical. All rights reserved. Powered by Software Genie
                    </small>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;